export const ENUM_SECTION_USEARCH_KEYS = {
  JOBS: 'jobs',
  PROFILES: 'profiles',
  COMPANIES: 'companies'
}
